import { toDotNotation } from '../functions'

import { themeVars, typographyVars } from './theme'

const { typography } = typographyVars
const { colors } = themeVars

export const colorPaths = toDotNotation(colors)
export const typographyPaths = toDotNotation(typography)
